export const MAX_CHAT_MESSAGE_LIMIT = 430;

export enum ClientType {
    viewer = 0,
    on_demand = 1,
    slide_viewer = 2,
    moderator = 3,
    presenter = 4,
    slide_controller = 5,
    editor = 6,
    speaker = 7
}

export enum ParticipantType {
    anonymous = 0,
    invited = 1,
    unverified_account = 1,
    verified_account = 2
}

export const ChatChannelIds = {
    publicChannel: '00000000-0000-0000-0000-000000000000',
    allChannel: '00000000-0000-0000-0000-000000000001',
    moderatorChannel: '00000000-0000-0000-0000-000000000002',
    presenterChannel: '00000000-0000-0000-0000-000000000003',
    speakersChannel: '00000000-0000-0000-0000-000000000004',
    isSystemChannel: (channelId: string) => {
        return (
            channelId === ChatChannelIds.publicChannel ||
            channelId === ChatChannelIds.allChannel ||
            channelId === ChatChannelIds.moderatorChannel ||
            channelId === ChatChannelIds.presenterChannel ||
            channelId === ChatChannelIds.speakersChannel
        );
    }
};

interface BaseChatMessage {
    timestamp: string;
    messageId: string;
    channelId: string;
    senderClientType: ClientType;
    senderParticipantId: string;
    senderNickname: string;
    message: string;
    isDeleted: boolean;
    isPermanentlyDeleted: boolean;
}

export interface ChatMessage extends BaseChatMessage {
    relationType?: ChatMessageRelationType;
    relatedMessage?: BaseChatMessage;
}

export enum ChatMessageRelationType {
    reply = 1,
    forward = 2
}

export interface ChatChannel {
    channelId: string;
    messages: ChatMessage[];
    noOfUnreadMessages: number;
}
